"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Handlebars = void 0;

var Handlebars_Helper = void 0;

Handlebars = require("handlebars");

Handlebars_Helper = function () {
  function Handlebars_Helper() {
    Handlebars.registerHelper("ifvalue", function (conditional, options) {
      if (options.hash.value === conditional) {
        return options.fn(this);
      } else {
        return options.inverse(this);
      }
    });
  }

  return Handlebars_Helper;
}();

exports.default = new Handlebars_Helper();